import { FC, memo, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '@chakra-ui/react'
import { FaCalendarPlus } from 'react-icons/fa'
import { ChakraPrimaryButton } from 'components/Button'

export interface AppointmentButtonProps {
  appointmentLink: string | undefined
  applyPrimaryStyle: boolean
  children: ReactNode
  onClick?: () => void
}

const AppointmentButton: FC<AppointmentButtonProps> = ({
  appointmentLink = '/schedule',
  applyPrimaryStyle,
  children,
  onClick,
}) => {
  return (
    <Link to={appointmentLink}>
      <ChakraPrimaryButton
        leftIcon={
          applyPrimaryStyle ? undefined : (
            <Icon as={FaCalendarPlus} transform="translateY(-1px)" />
          )
        }
        color={'var(--chakra-colors-white)'}
        width={'100%'}
        backgroundColor={
          applyPrimaryStyle ? 'var(--blue-dark)' : 'var(--blue-brand)'
        }
        onClick={onClick}
      >
        {children}
      </ChakraPrimaryButton>
    </Link>
  )
}

export default memo(AppointmentButton)
